import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddkt4eahtn: FaireProductEntity = {
  token: "p_ddkt4eahtn",
  type: "product",
  name: "Tropical Honu",
  brandName: "Bamboo Wood Stickers",
  imageUrl:
    "https://cdn.faire.com/fastly/2bc5a2a57f2f797229e78d187b1390f282aaa4ba8e6cbc0b81e642f3ac843073.jpeg",
  priceDollars: 1.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/924b1c922ee688fc653f37d5056aef9e5f11cde151cec7ef751ef092e7601867.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
